module.exports = __webpack_public_path__ + "img/79.86608f32.jpg";